import { type Event, getCurrentUserRole, getCurrentUserRsvp } from 'models';
import { useUser } from 'features/auth';
import { EventActions } from '../../components';

type P = {
  event: Event;
};

const EventActionsWrapper = ({ event }: P) => {
  const { nodeUserData: nodeViewer } = useUser();
  const currentUserRsvp =
    getCurrentUserRsvp({ participants: event.participants, viewerId: nodeViewer._id }) ?? 'pending';
  const currentUserRole =
    getCurrentUserRole({ participants: event.participants, viewerId: nodeViewer._id }) ?? 'attendee';

  if (event.type === 'reminder') {
    return null;
  }

  return <EventActions event={{ ...event, role: currentUserRole, rsvp: currentUserRsvp }} view="detail" />;
};

export default EventActionsWrapper;
